class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videoUrl = this.getAttribute('video-url');
    this.autoplay = this.getAttribute('autoplay') === 'true';
    this.href = this.getAttribute('href');
    this.isMuted = this.autoplay;
    this.customClasses = this.getAttribute('custom-classes') || ''; // New line
    this.showAudioControls = this.getAttribute('show-audio-controls') !== 'false'; // New line
    this.render();
  }

  render() {
    this.innerHTML = `
      <a href="${this.href}" class="video-link tw-block">
        <div class='tw-overflow-hidden tw-rounded-[6px] tw-relative'>
          <video
            loop
            ${this.autoplay ? 'autoplay muted' : ''}
            playsinline
            src='${this.videoUrl}'
            class='tw-relative tw-w-full tw-h-full tw-object-cover ${this.customClasses}'
          ></video>
          ${!this.autoplay ? this.renderPlayButton() : ''}
          <ul class="tw-absolute tw-bottom-2 tw-left-xs tw-flex tw-items-center tw-space-x-2">
            <li>${this.renderPauseButton()}</li>
            ${this.showAudioControls ? `<li>${this.renderVolumeControl()}</li>` : ''}
          </ul>
        </div>
      </a>
    `;

    if (!this.autoplay) {
      this.querySelector('.play-button').addEventListener('click', this.togglePlay.bind(this));
    }
    this.querySelector('.pause-button').addEventListener('click', this.togglePlay.bind(this));
    this.querySelector('.volume-control').addEventListener('click', this.toggleVolume.bind(this));

    // Prevent default link behavior when interacting with controls
    this.querySelectorAll('.play-button, .pause-button, .volume-control').forEach((control) => {
      control.addEventListener('click', (e) => e.preventDefault());
    });

    // Initialize control visibility
    this.updateControlsVisibility();
  }

  renderPlayButton() {
    return `
        <button
          class='play-button tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-text-white'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='48'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
          >
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        </button>
      `;
  }

  renderPauseButton() {
    return `
      <button
        class='pause-button tw-flex tw-items-center tw-justify-center tw-text-white'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        >
          <rect x='6' y='4' width='4' height='16'></rect>
          <rect x='14' y='4' width='4' height='16'></rect>
        </svg>
      </button>
    `;
  }

  renderVolumeControl() {
    return `
      <button
        style="width: 24px; height: 24px;"
        class='volume-control tw-flex tw-items-center tw-justify-center tw-text-white tw-w-6 tw-h-6 tw-rounded-full'
      >
        ${this.isMuted ? this.renderMutedIcon() : this.renderUnmutedIcon()}
      </button>
    `;
  }

  renderMutedIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
        <line x1="23" y1="9" x2="17" y2="15"></line>
        <line x1="17" y1="9" x2="23" y2="15"></line>
      </svg>
    `;
  }

  renderUnmutedIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
      </svg>
    `;
  }

  togglePlay(event) {
    event.preventDefault();
    const video = this.querySelector('video');
    video.paused ? video.play() : video.pause();
    this.updateControlsVisibility();
  }

  toggleVolume(event) {
    event.preventDefault();
    const video = this.querySelector('video');
    this.isMuted = !this.isMuted;
    video.muted = this.isMuted;
    this.updateVolumeControlIcon();
  }

  updateControlsVisibility() {
    const video = this.querySelector('video');
    const playButton = this.querySelector('.play-button');
    const pauseButton = this.querySelector('.pause-button');

    if (video.paused) {
      playButton?.classList.remove('tw-hidden');
      pauseButton.classList.add('tw-hidden');
    } else {
      playButton?.classList.add('tw-hidden');
      pauseButton.classList.remove('tw-hidden');
    }
  }

  updateVolumeControlIcon() {
    const volumeControl = this.querySelector('.volume-control');
    volumeControl.innerHTML = this.isMuted ? this.renderMutedIcon() : this.renderUnmutedIcon();
  }
}

customElements.define('video-player', VideoPlayer);
